import { useCallback, useState } from 'react';
import { toast } from 'react-toastify';
import { datadogRum } from '@datadog/browser-rum';
import api from '@services/api';
import type { SaleFunnelType } from '@customTypes/salesFunnels';

const useGetSalesFunnelsList = () => {
  const [salesFunnels, setSalesFunnels] = useState<SaleFunnelType[]>([]);
  const [totalPages, setTotalPages] = useState(0);
  const [loading, setLoading] = useState(true);

  const getSalesFunnels = useCallback(async ({ page = 1, limit = 10, name = '' }) => {
    setLoading(true);
    try {
      const response = await api.get('/sales_funnel', {
        params: {
          pageIndex: page,
          pageLimit: limit,
          name,
        },
      });
      setSalesFunnels(response.data.data);
      setTotalPages(response.data.total);
    } catch (error) {
      toast.error('Erro ao carregar os funis de vendas. Tente novamente mais tarde.');
      datadogRum.addError(new Error('Fail to get sales funnels list'), {
        error,
        name,
      });
    } finally {
      setLoading(false);
    }
  }, []);

  return {
    getSalesFunnels,
    salesFunnels,
    totalPages,
    loading,
  };
};

export default useGetSalesFunnelsList;
